module.exports = __webpack_public_path__ + "static/img/bw.d1585fdf.svg";